/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container, Row, Card,CardBody } from "reactstrap";

// core components

function Logos() {
  return (
    <>
      <Card style={{marginBottom:'2em'}}>
        <CardBody>
          <b>Entidades, agremiaciones y asociaciones</b>
          <div className="row logos-responsive align-items-center">
            <div className="col-md-1 col-sm-2 col-4 d-flex align-items-center justify-content-center" style={{ marginLeft:'4em' }}>
              <a target="_blank" rel="noopener noreferrer" href="https://www.procuraduria.gov.co/portal/" style={{display: "flex", alignItems: "center", width: "100%"}}>
                <img
                  alt="Logo de Procuraduria General de la Nacion"
                  src={require("assets/img/sections/procuraduria.jpg")}
                  style={{width: "100%", height: "auto", display: "block"}}
                ></img>
              </a>
            </div>
            <div className="col-md-2 col-sm-2 col-4 d-flex align-items-center justify-content-center">
              <a target="_blank" rel="noopener noreferrer" href="http://www.minjusticia.gov.co/" style={{display: "flex", alignItems: "center", width: "100%"}}>
                <img
                  alt="Logo de Ministero de Justicia y Derecho de Colombia"
                  src={require("assets/img/sections/minJusticia2.png")}
                  style={{width: "100%", height: "auto", display: "block"}}
                ></img>
              </a>
            </div>
            <div className="col-md-2 col-sm-2 col-4 d-flex align-items-center justify-content-center">
              <a target="_blank" rel="noopener noreferrer" href="https://www.supernotariado.gov.co/" style={{display: "flex", alignItems: "center", width: "100%"}}>
                <img
                  alt="Logo de SNR y Registro"
                  src={require("assets/img/sections/SNR.png")}
                  style={{width: "100%", height: "auto", display: "block"}}
                ></img>
              </a>
            </div>
            <div className="col-md-1 col-sm-2 col-4 d-flex align-items-center justify-content-center">
              <a target="_blank" rel="noopener noreferrer" href="https://www.vur.gov.co/" style={{display: "flex", alignItems: "center", width: "100%"}}>
                <img
                  alt="Logo del VUR"
                  src={require("assets/img/sections/vur.png")}
                  style={{width: "100%", height: "auto", display: "block"}}
                ></img>
              </a>
            </div>
            <div className="col-md-1 col-sm-2 col-4 d-flex align-items-center justify-content-center">
              <a target="_blank" rel="noopener noreferrer" href="https://www.registraduria.gov.co/" style={{display: "flex", alignItems: "center", width: "100%"}}>
                <img
                  alt="Logo Registraduria Nacional del estado civil"
                  src={require("assets/img/sections/registraduria.png")}
                  style={{width: "100%", height: "auto", display: "block"}}
                ></img>
              </a>
            </div>
            <div className="col-md-1 col-sm-2 col-4 d-flex align-items-center justify-content-center">
              <a target="_blank" rel="noopener noreferrer" href="https://www.suin-juriscol.gov.co/" style={{display: "flex", alignItems: "center", width: "100%"}}>
                <img
                  alt="Logo SUIN Juriscol"
                  src={require("assets/img/sections/suin.png")}
                  style={{width: "100%", height: "auto", display: "block"}}
                ></img>
              </a>
            </div>
          </div >
        </CardBody>
      </Card>
      <Card style={{marginBottom:'0px'}}>
        <CardBody>
          <b>Directorio de agremiaciones, asociaciones y otro grupos de interesés</b>
          <div className="row text-center logos-responsive">
            <div className="col-md-2 col-sm-2 col-6" style={{ marginTop:'2em' }}>
              <a  target="_blank" rel="noopener noreferrer" href="https://www.ucnc.com.co/sitio/">
                <img
                  alt="Logo de la Unión Colegiada del Notariado Colombiano"
                  className='log'
                  src={require("assets/img/sections/notario.jpg")}
                ></img>
              </a>
            </div>
            <div className="col-md-1 col-sm-2 col-6" style={{ marginTop:'1em' }}>
              <a  target="_blank" rel="noopener noreferrer" href="https://www.uinl.org/america-american-affairs-commission-caam-">
                <img
                  alt="Logo de la Comisión de Asuntos Americanos"
                  className="logos"
                  src={require("assets/img/sections/comision.png")}
                ></img>
              </a>
            </div>
          </div >
        </CardBody>
      </Card>
      {/* Responsive styles for mobile */}
      <style>{`
        @media (max-width: 576px) {
          .logos-responsive {
            flex-wrap: wrap !important;
            margin-left: 0 !important;
            margin-right: 0 !important;
          }
          .logos-responsive .col-4, .logos-responsive .col-6 {
            margin-bottom: 1em !important;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .logos-responsive img {
            width: 70px !important;
            height: auto !important;
            margin: 0 !important;
          }
        }
      `}</style>
    </>
  );
}
export default Logos;
